import {
	DiHtml5,
	DiCss3,
	DiJavascript,
	DiReact,
	DiSass,
	DiGit,
	DiGithubBadge,
	DiW3C,
	DiBootstrap,
	DiHeroku,
	DiJqueryLogo,
} from 'react-icons/di';
import {
	SiAntdesign,
	SiVite,
	SiRedux,
	SiTypescript,
	SiTailwindcss,
	SiEthereum,
	SiExpress,
	SiGraphql,
	SiNetlify,
	SiVercel,
	SiNextdotjs,
	SiMongodb,
	SiJest,
	SiFramer,
	SiFirebase,
	SiSocketdotio,
} from 'react-icons/si';

export const technologies = {
	proLanguages: [
		{ name: 'Javascript', icon: <DiJavascript /> },
		{ name: 'Typescript', icon: <SiTypescript /> },
	],
	UI: [
		{ name: 'HTML', icon: <DiHtml5 /> },
		{ name: 'CSS', icon: <DiCss3 /> },
		{ name: 'TailwindCss', icon: <SiTailwindcss /> },
		{ name: 'Framer Motion', icon: <SiFramer /> },
		{ name: 'Redux', icon: <SiRedux /> },
	],
	webFramesWork: [
		{ name: 'React', icon: <DiReact /> },
		{ name: 'Next.js', icon: <SiNextdotjs /> },
		{ name: 'JQuery', icon: <DiJqueryLogo /> },
		{ name: 'Ant Design', icon: <SiAntdesign /> },
		{ name: 'Sass', icon: <DiSass /> },
		{ name: 'Bootstrap', icon: <DiBootstrap /> },
		{ name: 'Ether.js', icon: <SiEthereum /> },
		{ name: 'Web3.js', icon: <DiW3C /> },
		{ name: 'GraphQL', icon: <SiGraphql /> },
		{ name: 'WebSockets', icon: <SiSocketdotio /> },
		{ name: 'Express', icon: <SiExpress /> },
		{ name: 'Jest', icon: <SiJest /> },
		{ name: 'Firebase', icon: <SiFirebase /> },
		{ name: 'MongoDB', icon: <SiMongodb /> },
		{ name: 'Vite', icon: <SiVite /> },
	],
	concepts: [
		'Design Systems',
		'PWAs',
		'Performance Optimisation',
		'MVC',
		'Responsive Web Design',
	],
	hosting: [
		{ name: 'Heroku', icon: <DiHeroku /> },
		{ name: 'Vercel', icon: <SiVercel /> },
		{ name: 'Netlify', icon: <SiNetlify /> },
	],
	CICD: [
		{ name: 'Git', icon: <DiGit /> },
		{ name: 'Github', icon: <DiGithubBadge /> },
	],
};
